import {Localized} from "@fluent/react";
import React from "react";

import ChipsSelector from "../../utils/ChipsSelector";
import type ResolutionStatus from "./ResolutionStatus";

const statuses: ResolutionStatus[] = ["not_resolved", "fixed", "irrelevant"];

function ResolutionStatusFilter(props: {
	value: ResolutionStatus[];
	onChange: (val: ResolutionStatus[]) => void;
}) {
	return (
		<ChipsSelector
			options={statuses}
			value={props.value}
			onChange={props.onChange}
			getOptionLabel={(opt) => (
				<Localized
					id="content-issues-widget-resolution-status-filter-option"
					vars={{option: opt}}
				>
					{opt}
				</Localized>
			)}
		/>
	);
}

export default ResolutionStatusFilter;
